import React from 'react'
import { useFlagRequirementCounts } from './hooks/useFlagRequirementCounts'

export default function FlagStatusSummary({ packageId, totalRequirements }) {
  const { incompleteCount, completeCount } = useFlagRequirementCounts()

  return (
    <div className="flag-status-summary">
      <div className="flag-status-summary__requirements">
        <span className="flag-status-summary__label">requirements:</span>
        <span className="flag-status-summary__value">{totalRequirements}</span>
      </div>
      <div className="flag-status-summary__counts">
        <div className="flag-status-summary__count">
          <span className="flag-status-summary__count-label">incomplete</span>
          <span className="flag-status-summary__count-value">{incompleteCount}</span>
        </div>
        <div className="flag-status-summary__count">
          <span className="flag-status-summary__count-label">complete</span>
          <span className="flag-status-summary__count-value">{completeCount}</span>
        </div>
      </div>
    </div>
  )
}
